export default {
  setQuestions(state, data) {
    state.questions = data
  },
  setTicketFormByQuestions(state, data) {
    state.ticketFormByQuestions = data
  },
  updateTicketForm(state, { key, value }) {
    state.ticketForm = {
      ...state.ticketForm,
      [key]: value,
    }
  },
  clearQuestionTicketState(state) {
    state.questions = []
    state.ticketFormByQuestions = {}
    state.ticketForm = {}
  },
  setTicketForm(state, data) {
    state.ticketForm = data
  },
  setParentQuestionId(state, id) {
    state.parentQuestionId = id
  },
  setQuestionsSections(state, data) {
    state.questionsSections = data
  },
}
